import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RoutingProfileAction } from '../routingProfile.action';
import { RoutingProfileTranslator } from '../routingProfile.translator';

type IDependencies = IClientApiDependencySegment;

export const updateRoutingProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(RoutingProfileAction.update.started),
  switchMap(({ params, reject }) => {
    return dependencies.api.updateRoutingProfile(RoutingProfileTranslator.toApi(params)).pipe(
      mergeMap(() => {
        return [RoutingProfileAction.update.done({ params })];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          RoutingProfileAction.update.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
